<template>
  <div class="home">
    <van-nav-bar v-if="page==1" title="用户协议" left-arrow @click-left="onClickLeft"/>
    <div class="container">
      <h1>禽智养殖用户注册协议</h1>
      <p>本《用户注册协议》由您（以下称“用户”、“您”）与北京中科基因技术有限公司（以下简称“中科基因”、“我们”）就您使用“禽智养殖”应用程序/平台服务所达成的有效协议(下称"本协议")。</p>
      <p><strong>请您在使用禽智养殖服务前务必事先认真阅读本协议中的各条款，特别是其中所涉及您和我们权利义务的条款，并在阅读后选择"接受"或"拒绝"本协议。</strong>同时，您应当主动了解平台不定期发布的公告、通知等文件内容。除非您接受本协议所有条款，否则您将无法使用禽智养殖服务。您一经注册并点击确认或同意或使用中科基因服务即视为对本协议全部条款已充分理解并完全接受。</p>
      <h2>一、声明与承诺</h2>
      <p>1.您确认，在您注册成为禽智养殖用户接受本服务前，已充分阅读、理解并接受本协议的全部内容，一旦您签署本协议，即意味着您须按照本协议约定使用禽智养殖服务，若您给禽智养殖或其他用户造成损失的，您应当承担相应责任。</p>
      <p>2.您同意并知晓，我们有权对本协议内容进行修改或变更，并将以公告、邮件、短信推送及禽智养殖平台弹窗或其他方式予以公布，您可以通过禽智养殖应用程序/平台等途径查阅；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务或注销禽智养殖账号。</p>
      <p>3.您保证，在您同意接受本协议并注册成为中科基因用户时，您已经年满18周岁，具有完全民事行为能力。如您不具备前述条件，您应终止注册或停止使用本服务。</p>
      <h2>二、中科基因账户</h2>
      <h3>注册：</h3>
      <p>您在申请注册禽智养殖账户时，我们需要收集和使用您的相关信息。您应当准确提供并及时更新您提供的联系电话信息，以便我们与您进行及时、有效联系。如您提供的注册资料不合法、不真实、不准确的，您需承担因此引起的相应责任和后果。</p>
      <h3>使用：</h3>
      <p>您应当确保申请禽智养殖的账户仅能为您本人使用，并妥善保管账户密码，若您擅自转让、出租给第三方使用导致中科基因或您的权益受损，由您承担该责任。当您账户被盗用时，应当及时联系禽智养殖申请暂停服务，避免扩大您的损失。</p>
      <h2>三、 您信息的使用授权和保护</h2>
      <p>1. 中科基因尊重并保护您的个人信息，我们将严格按照本协议及具体服务中与您关于信息授权的约定，收集、使用、存储、披露您的您个人信息。</p>
      <p>1）您以任何方式使用中科基因公司的相关服务，即表示您已充分阅读、理解并同意接受相应的服务协议；</p>
      <p>3.您应当认真阅读本协议条款，如您不同意本协议关于您信息使用或具体服务中的任一项关于您的个人信息授权的约定，您可能无法使用中科基因服务，<strong>当您点击“确认”或“同意”本协议视为您同意本协议约定内容并授权我们按如下约定收集、保存、分析、使用、向第三方提供您的相关个人信息：</strong></p>
      <h3>1）用户注册</h3>
      <p>当您注册时，您需要向我们提供您本人的手机号码、注册验证码信息。请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除您删除或通过系统设置拒绝我们收集之外，我们将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用，删除您的个人信息或对您个人信息进行匿名化处理。</p>
      <p>我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。。</p>
      <h3>2) 存在以下情形中，我们收集、使用您的个人信息无需征得您的授权同意：</h3>
      <p>a.与国家安全、国防安全有关的；b.与公共安全、公共卫生、重大公共利益有关的；c.与犯罪侦查、起诉、审判和判决执行等有关的；d.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；e.所收集的个人信息是个人信息主体自行向社会公众公开的；f.从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；g.根据您的要求签订合同所必需的；h.用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；i.为合法的新闻报道所必需的；j.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；k.法律法规规定的其他情形。</p>
      <!-- <h3>3) 快速提问</h3>
      <p>使用该功能需要您在APP内进行文字录入以及语言消息，我们会记录您的声音，进而获取其中的声音信息（该信息属于个人敏感信息）。您在使用该产品时所产生的指令、会话等信息（手动键盘输入的文字信息）、当前地理位置、获知当前前台应用的名称以及运行状态 等信息这些信息会经过脱敏处理后上传至阿里云服务器进行存储</p>
      <h3>4) 远程诊断</h3>
      <p>使用该功能需要您在APP内进行视频通话，通过允许设置访问设备的摄像头以及音频，此应用调用第三方应用开放接入接口，由三方服务方应用为您提供相应的服务（例如：在线咨询聊天、视频问诊等》、我们会将第三方服务方/应用所需要的信息提供给对方。此过程中按照相关规定全程进行加加密处理，保护用户的信息。</p> -->
      <h2>四、 知识产权</h2>
      <p>1. 禽智养殖有用应用程序/平台及服务的著作权、商标权、商业秘密以及其他相关的知识产权，包括但不限于各种文档资料、软件、商标、FLASH、设计、图案、音像、摄影、动画、美术等，及其它本协议中未经提及的知识产权均由中科基因享有。</p>
      <p>2.未经我们事先书面同意，您不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何第三方实施、利用、转让上述知识产权。</p>
      <h2>五、 免责条款</h2>
      <p>禽智养殖APP因线路维修、故障、黑客攻击、电信部门技术调整或故障、网站升级、银行方行为或原因、意外事件、不可抗力等状况无法正常运作，使您无法使用各项服务时，我们不承担损害赔偿责任。</p>
      <h2>六、 违约责任</h2>
      <p>1.您在使用中科基因服务时，应严格遵守本协议的约定。若您有任何违反本协议或相关法规的规定，我们有权视您的行为性质，在不事先通知您的情况下，采取包括但不限于中断使用许可、限制使用、中止或终止服务、追究法律责任等措施，若因此造成中科基因或他人损失的，您应予赔偿。</p>
      <p>2.您不得利用中科基因产品进行任何违反国家现行法律及各法规、损害社会集体、损害中科基因、中科基因合作方或任何其他第三方的利益的行为，否则我们有权立即终止为您提供服务，并要求您赔偿损失，由此产生的后果由您自行承担。</p>
      <p>3.我们有权判定您的行为是否符合本协议的要求，出现包括但不限于以下情形的，我们有权单方在不作通知的情况下终止对您提供的服务，由此产生的风险及责任由您自行承担。如造成我们损失的，您还应承担赔偿等责任：</p>
      <p>1) 您提供的资料不真实；</p>
      <p>2) 您违反本协议中规定的使用规则；</p>
      <p>3) 您未按时足额支付使用禽智养殖服务的费用（如有）；</p>
      <p>4) 您违反本协议其它规定，且自禽智养殖通知其纠正之日起10个工作日内仍未纠正的。</p>
      <h2>七、 执行和变更</h2>
      <p>我们有权根据需要修改、增加或删减本协议并将以公告、邮件、短信推送及禽智养殖弹窗或其他方式通知您相关修改、增加或删减的内容。一经前述方式进行公告的，即视为上述内容已经通知到您。若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务或注销中科基因账号。</p>
      <h2>八、 适用法律</h2>
      <p>本协议适用于中华人民共和国大陆地区法律、法规。若您和我们之间发生任何纠纷或争议，应友好协商解决，协商不成的，您可将纠纷或争议提交中科基因所在地北京大兴区区人民法院诉讼解决。</p>
      <h2>九、 联系我们</h2>
      <p class="address-p">如果您对本协议有任何问题，请通过以下途径联系中科基因</p>
      <p class="address-p">办公地址： 北京市大兴区生物医药基地永大路38号5栋</p>
      <p class="address-p">联系方式：客服电话010-62142951或者客服邮箱han.xiaoxue@sslab.com.cn</p>
      <p class="address-p">中科基因会尽最大努力在合理时间内回复您</p>
      <p class="address">生效日期： 2021年10月22日</p>
    </div>
  </div>
</template>

<script>
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'announcement',
  data(){
    return{
      page: '',
      tiem: '',
      timer: '',
      goodsList: [],
    }
  },
  created(){
    this.page = this.$route.query.page
    document.title = '禽智养殖'
  },
  methods: {
    onClickLeft() {
      // this.$router.back(-1)
      this.$router.replace('/expertlogin')
    }
  }
}
</script>

<style lang="scss">
.home {
  max-width: 780px;
  margin: 0 auto;
}
.container {
  padding: 20px 10px;
  h1 {
    text-align: center;
    font-size: 16px;
    padding-bottom: 10px;
  }
  h2 {
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 5px;
  }
  h3 {
    padding: 5px 0;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
  }
  p {
    padding-bottom: 10px;
    text-align: left;
    line-height: 20px;
    font-size: 12px;
    color: #000;
  }
  strong {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    color: #000;
  }
  .address-p {
    padding-bottom: 0;
  }
  .address {
    padding: 10px;
    text-align: right;
  }
}
</style>
